module.exports = __webpack_public_path__ + "resources/img/theme_ekyc.gif";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/theme_ekyc.gif
// module id = 1371
// module chunks = 0